import { render, staticRenderFns } from "./ContactIntro.vue?vue&type=template&id=51242656&scoped=true&"
import script from "./ContactIntro.vue?vue&type=script&lang=js&"
export * from "./ContactIntro.vue?vue&type=script&lang=js&"
import style0 from "./ContactIntro.vue?vue&type=style&index=0&id=51242656&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51242656",
  null
  
)

export default component.exports